<template>
  <div class="order-give-audit">
    <div class="tuolele-main-box">
      <div class="tuolele-main-search">
        <el-form :inline="true" :model="search">
          <el-form-item label="选择店铺">
            <el-select v-model="search.shop_id">
              <el-option label="全部" value="0" />
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="赠送类型">
            <el-select v-model="search.give_type">
              <el-option label="全部" value />
              <el-option
                v-for="item in giveType"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="getGiveList"
          >查询</el-button>
        </el-form>
      </div>
    </div>
    <div class="table-header fn-clear">
      <div class="fn-right table-header-right">
        <el-pagination
          :current-page.sync="search.p"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search.limit"
          layout="sizes, prev, slot, next"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          @size-change="handleSizeChange"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :data="dataInfo.list" border stripe>
        <el-table-column
          prop="create_time"
          label="创建时间"
          sortable
        />
        <el-table-column
          prop="modify_time"
          label="最后操作时间"
          sortable
        />
        <el-table-column prop="shop_name" label="店铺" />
        <el-table-column label="学员">
          <template slot-scope="scope">
            <div class="color-black">{{ scope.row.child_name }}</div>
            <div class="color-gray">ID：{{ scope.row.child_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="赠送类型">
          <template slot-scope="scope">
            <div>{{ scope.row.give_type_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="课时类型">
          <template slot-scope="scope">
            <div>{{ scope.row.item_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="editor_name" label="提交人" />
        <!-- <el-table-column label="订单审核状态">
          <template slot-scope="scope">
            <div class="color-black">{{scope.row.status | orderStatus}}</div>
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="getOrderInfo(scope.row)"
            >审核订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="search.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="search.limit"
        >
          <div class="chax">
            {{ search.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / search.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div>
    <el-dialog
      title="赠送审核"
      :visible.sync="dialogVisible1"
      width="40%"
      class="order-detail-dialog"
    >
      <OrderGiveInfo
        :order-detail="orderDetail"
        @updateOrderList="getGiveList"
      />
    </el-dialog>
  </div>
</template>
<script>
import OrderGiveInfo from '@/components/order/OrderGiveInfo.vue'
export default {
  name: 'OrderGiveAudit',
  components: {
    OrderGiveInfo
  },
  data() {
    return {
      search: {
        p: 1,
        limit: 10,
        shop_id: '',
        give_type: '',
        status: '1'
      },
      shopList: [],
      giveType: [],
      dataInfo: {},
      itemTotal: 0,
      dialogVisible1: false,
      orderDetail: {}
    }
  },
  // filters: {
  //   orderStatus(val1) {
  //     if (val1 == "0") {
  //       return "待校长审核";
  //     } else if (val1 == "1"){
  //       return "待财务审核";
  //     } else if (val1 == "2") {
  //       return "审核成功";
  //     } else if (val1 == "3") {
  //       return "审核失败";
  //     }
  //   }
  // },
  mounted() {
    this.getGiveType()
    this.getMyShopList()
    this.getGiveList()
  },
  methods: {
    getGiveType() {
      this.$http.getGiveType().then(res => {
        this.giveType = res.data
      })
    },
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
    },
    getGiveList() {
      this.dialogVisible1 = false
      this.$http.getGiveList(this.search).then(res => {
        this.dataInfo = res.data
        this.itemTotal = res.data.count - 0
      })
    },
    getOrderInfo(row) {
      this.$http.getGiveInfo({ billing_id: row.billing_id }).then(res => {
        this.orderDetail = res.data
        this.dialogVisible1 = true
      })
    },
    handleSizeChange(val) {
      this.search.limit = val
    }
  }
}
</script>

<style lang="scss">
.order-give-audit {
  .el-form .el-select {
    width: 180px !important;
    margin-right: 20px;
  }
  .flex-con {
    margin-right: 30px;
  }
  .flex-con:last-child {
    margin-right: 0;
  }
  .order-count {
    height: 160px;
    color: #fff;
    padding: 30px 0 0 30px;
    margin: 0 auto;
    background: url(../../assets/img/price-bg.png) #4c84ff right bottom
      no-repeat;
    background-size: 96px 117px;
    border-radius: 10px;
    span {
      font-size: 20px;
      margin-bottom: 25px;
    }
    p {
      font-size: 40px;
    }
  }
  .table-header {
    margin-bottom: 20px;
  }
  .el-table td {
    border: 1px solid #f5f5f5;
  }
  .refund-bill-list {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f5f5f5;
    div {
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}
</style>
